// extracted by mini-css-extract-plugin
module.exports = {"modal":"GalleryModal_modal__2b-6u","image":"GalleryModal_image__1114N"};